export const KYC_STATUS = {
  fail: 'fail',
  pass: 'pass',
  partial: 'partial'
};

export const KYC_ERROR_CODES = {
  challenge: 'ERR_KYC_PARTIAL_FAIL_CHALLENGE',
  partial: 'ERR_KYC_PARTIAL_FAIL',
  fail: 'ERR_KYC_FAIL',
  timeout: 'KBA_QUESTION_TIMEOUT',
  pass: 'ERR_KYC_SUCCESS'
};

export const HTTP_ERROR_CODES = {
  unauthorized: 'ERR_UNAUTHORIZED',
  invalidIPAddress: 'ERR_AUTHORIZATION_WRONG_IP'
};

export const ERR_ALREADY_REGISTERED = 'ERR_ALREADY_REGISTERED';
